import { Injectable } from '@angular/core';
import { AppHttpClient } from './app-http-client.service';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  ARTIFACTS_ORDERS = [];

  constructor(public http: AppHttpClient) { }

  getArtifactOrders() {
    return this.http.get('artifact/order').pipe(
      tap((res: any) => {
        this.ARTIFACTS_ORDERS = res || [];
      })
    );
  }
}

export function initializeApp(configService: AppConfigService) {
  return () => configService.getArtifactOrders();
}
